export { b as createHooksInternal, a as createReactProxyDecoration, c as createReactQueryUtilsProxy } from '../createHooksInternal-163d1042.mjs';
import '@trpc/server/shared';
import '@tanstack/react-query';
import '@trpc/client';
import 'react';
